import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { RolData } from "../slices/rolSlice";
import { IUsersData } from "../slices/usersSlice";
import { useGetAllTeams } from "../hooks/useGetAllTeams";
import { TeamData } from "../slices/teamSlice";
import { UserTooltip } from "@/components/UI";
import UIcon from "@/assets/uicons/UIcon";
import styles from '../styles/usersTable.module.scss';

export interface UserBodyTable {
  user: IUsersData;
  inacUser: (username: string) => void;
  onEditUser: (user: IUsersData) => void;
  filter: number;
}

export const BodyTableUsers = ({ user, inacUser, onEditUser, filter }: UserBodyTable) => {
  const { data: teams } = useGetAllTeams({ enabled: true });
  const { roles } = useSelector((state: RootState) => state.roles);

  const setRol = (rolname: string) => {
    const date = Array.isArray(roles) ? roles.filter((role: RolData) => role.name === rolname) : [];
    return date[0]?.name || rolname;
  };

  const setTeam = (id: number) => {
    if (!id) return 'UNKNOWN';
    const teamFiltered = Array.isArray(teams?.data) ? teams?.data?.filter((team: TeamData) => team.id === id) : [];
    return teamFiltered.length > 0 ? teamFiltered[0]?.areaName : 'NO DATA';
  };

  const fullName = [user.firstname, user.firstlastname].filter(Boolean).join(' ');
  const displayName = fullName || user.username;
  const avatarName = [user.firstname, user.firstlastname].filter(Boolean).join('+') || user.username;
  const avatarUrl = user.picture || `https://ui-avatars.com/api/?name=${avatarName}&background=random`;

  const userTooltipData = {
    name: displayName,
    avatarUrl: avatarUrl,
    role: setRol(user.role),
    email: user.email,
    phone: user.telephone,
    team: setTeam(user.idarea),
  };

  return (
    <div className={styles["user-table__row"]}>
      {/* Avatar & Name */}
      <div className={styles["user-table__cell"] + ' ' + styles["user-table__cell--name"]}>
        <UserTooltip
          user={userTooltipData}
          placement="top"
        >
          <div className={styles["user-table__avatar-name-wrapper"]}>
            <div className={styles["user-table__avatar"]}>
              <img src={avatarUrl} alt={displayName} />
            </div>
            <span>{displayName}</span>
          </div>
        </UserTooltip>
      </div>
      {/* Email */}
      <div className={styles["user-table__cell"] + ' ' + styles["user-table__cell--email"]}>{user.email}</div>
      {/* Rol */}
      <div className={styles["user-table__cell"] + ' ' + styles["user-table__cell--role"]}>{setRol(user.role)}</div>
      {/* Equipo */}
      <div className={styles["user-table__cell"] + ' ' + styles["user-table__cell--team"]}>{setTeam(user.idarea)}</div>
      {/* Acciones */}
      <div className={styles["user-table__cell"] + ' ' + styles["user-table__cell--actions"]}>
        <button className={styles["user-table__action-btn"]} onClick={() => onEditUser(user)}>
          <UIcon name="edit" size={20} />
        </button>
        <button className={styles["user-table__action-btn"]} onClick={() => inacUser(user.username)}>
          <UIcon name={filter === 11 ? "like" : "trash"} size={20} />
        </button>
      </div>
    </div>
  );
}
